import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { ClassifierService } from '../../services/classifier.service';

import { IUser } from '../../models/User';
import { IClassifier } from '../../models/Classifier';
import { ITableColumn } from '../../shared/table/table.component';
import { UserService } from '../../services/user.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: UserService,
        private classifiers: ClassifierService
    ) { }

    readonly columns: ITableColumn[] = [
        { property: 'UserName', label: 'userslist_lblUserName', sorts: true },
        { property: 'Name', label: 'userslist_lblName', sorts: true },
        { property: 'Surname', label: 'userslist_lblSurname', sorts: true },
        { property: 'Email', label: 'userslist_lblEmail', sorts: true },
        { property: 'Roles', label: 'userslist_lblRoles', sorts: true },
        { property: 'Created', label: 'userslist_lblCreated', sorts: true, type: 'date' },
        { property: 'LastLogin', label: 'userslist_lblLastLogin', sorts: true, type: 'date' }
    ];

    users: IUser[] = [];
    roles: IClassifier[];

    filterRole: IClassifier;
    searchValue: string;

    page: number = 1;
    readonly pageSize: number = 10;
    total: number = 0;
    sortBy: string;
    sortDir: 'asc' | 'desc';

    private filterSubj = new Subject();

    ngOnInit() {
        this.filterSubj.pipe(debounceTime(300)).subscribe(() => {
            this.fetch();
            this.page = 1;
        });

        this.app.addLoading(this.classifiers.get('UserRole', true)).subscribe(roles => {
            roles.sort((a, b) => {
                return (a.Value || '').localeCompare(b.Value || '');
            });

            this.roles = roles;
        });

        this.fetch();
    }

    onPage(event: number) {
        this.page = event;
        this.fetch();
    }

    onSort(event: { sortBy: string, sortDir: 'asc' | 'desc' }) {
        this.sortBy = event.sortBy;
        this.sortDir = event.sortDir;
        this.fetch();
    }

    getRoleString(item: IUser) {
        return item.Roles.join(', ');
    }

    filter() {
        this.filterSubj.next();
    }

    private fetch() {
        this.app.addLoading(this.service.get({
            page: this.page,
            size: this.pageSize,
            dir: this.sortDir,
            sort: this.sortBy
        }, {
            role: this.filterRole?.Code,
            search: this.searchValue
        })).subscribe(data => {
            this.users = data.items;
            this.total = data.total;
        });
    }
}
